/**
 * HeatmapLegend Component
 * "Less" to "More" color scale legend for the activity heatmap
 */

import { getColor, CELL_SIZE } from './heatmapUtils'

/**
 * Legend component showing the color scale
 * @param {Object} props - Component props
 * @param {boolean} props.isDark - Whether dark mode is active
 */
function HeatmapLegend({ isDark = false }) {
  // Generate color squares for legend (empty + 4 levels)
  const levels = [0, 1, 2, 3, 4]

  return (
    <div className="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400">
      <span>Less</span>
      <div className="flex gap-0.5">
        {levels.map((level) => (
          <div
            key={level}
            className="rounded-sm"
            style={{
              width: CELL_SIZE,
              height: CELL_SIZE,
              backgroundColor: getColor(level, isDark)
            }}
          />
        ))}
      </div>
      <span>More</span>
    </div>
  )
}

export default HeatmapLegend
